module.exports = __webpack_public_path__ + "img/55s.9681c8d8.png";